module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch06"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("•")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("La Mamma")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterSubtitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("When Mary Coates—twenty-five years old, pregnant, separated from her husband, set on divorcing and continuing a career in fashion illustration—stepped back over the threshold of the Coates family boardinghouse in Fort Worth, Texas, she surrendered much of her maternal authority. Her departure for Chicago to look for a job three weeks after she gave birth to her baby girl transferred whatever was left of that power."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00000"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00000",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" Mary’s infant came under the jurisdiction of the woman who, as Mary wrote plaintively, had “tried her sorely,” curbed her socially (“In high school I finally quit having dates [she] was so hard on me about them”), and made her feel a parental disapproval so strong that Mary swore “no daughter of mine would suffer that.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00001",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This commanding figure, still dominating Mary well into middle age, was the diminutive, nearsighted, Alabama-born doctor’s daughter whose double first name bridged both genders, whose Southern Calvinist heritage was founded on Puritan rock—her great-grandson Don says that “her back never touched a chair’s back”—and whose rule over the Coates family was absolute: Mary’s mother and Pat’s grandmother, the invincible Willie Mae Stewart Coates.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Grandma,” says Willie Mae’s great-grandson Don, “was a tiny little thing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you saw Grandma in a car sitting in a passenger seat, the only thing you saw above the doorline was her head. And Grandpa was just as tall as he could be.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Don’s elder brother Dan remembered: “Willie Mae was the cutest, toughest little ‘toot’ who ever lived. Mary came by her strong personality from Willie Mae.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In home movies of the Coates family shot in Texas in the 1930s and 1940s, it is the self-possessed Willie Mae who draws the spectator’s gaze, just as Mary and Pat do when they’re being filmed or photographed with other people. Mary Highsmith, in a typical family film shot at her Hastings-on-Hudson house in New York State, has put a stalk of celery in her hair, and her mugging and manifestations for the camera manage to crowd nearly everyone else out of the frame. Pat, the reverse "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("médaille")]), _vm._v(" of this regiment of camera-ready women, makes herself as starched, as stiff, and as still as possible whenever she is caught on film. Her visual grammar is that of the reluctant star of a hostage video."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00002",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In photographs, Willie Mae and Mary resemble each other closely; Mary is the elongated, modish, nervous, flirtatious version of her mother. Pat, with her cat-shaped eyes, oval visage, and black hair, looks like no one in the Coates or Stewart (Willie Mae’s maiden name) family. Of the three generations of women, it is Willie Mae who moves with the kind of definition and authority that allowed her to make such an impression—such a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("different")]), _vm._v(" impression—on the lives of both Mary and Patricia Highsmith."), _c('span', {
    staticClass: "endnoteRef",
    attrs: {
      "id": "fnt19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end02#fnt_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Willie Mae Stewart Coates was born in Alabama in September of 1866. Much of the personal power she always seemed to possess came from the Calvinist line in her heritage, stretching backwards for generations. Her long family history of religious devotion and involvement in social justice was marked by the spiritual rebellions and odd, intense pieties that would trouble her granddaughter Patricia all her life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the careful genealogy worked out in 1954 by the biographer of Pat’s relation,"), _c('span', {
    staticClass: "endnoteRef",
    attrs: {
      "id": "fnt20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end02#fnt_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _vm._v(" Confederate general A. P. Stewart (later president of the University of Misssippi at Oxford), the Stewart family to which Willie Mae Coates belonged was firmly established as being of Scots-Irish origin. The American branch of the Stewart clan associated itself with the tonier “Baltimore Stewarts,” and Willie Mae’s grandfather, William Stewart, was second-generation Scots-Irish. He traced his origins, Pat was pleased to note, to Ninion Stewart, younger son of James I of Scotland and brother of James II."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00003",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William Stewart, whose maternal grandfather was a Presbyterian minister, moved from his birthplace in Delaware to Tennessee, where he became the postmaster of Winchester and the treasurer of Franklin County: a leading citizen and a public official. The records of the Winchester, Tennessee, Masonic Lodge No. 158 show that he was a Presbyterian and a “man of undoubted piety”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00004",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])])]), _vm._v(" whose reverence took a curiously physical turn: his “frequent and protracted kneeling in the act of prayer” are said to have worn holes in his bedroom carpet."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00005",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])])]), _vm._v(" He married Elizabeth Decherd (now spelled Deckerd), and Elizabeth, a serious convert to Methodism, bore sixteen children and died in 1847, a “bright ornament of the Methodist Church.” She, too, was intensely devout: “a truly praying woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Stewart children were raised in the Presbyterian church, although two of the Stewart sons became well-known Methodist preachers. These conversions to (and promulgations of) Methodism in a devotedly Presbyterian family were as shocking a heresy in their day as an open profession of Communism would have been in the McCarthy era."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00006",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" Pat’s grandmother Willie Mae, who followed the family’s Methodist line, joined the St. Mark’s Methodist Church in Fort Worth."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00007",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])])]), _vm._v(" Affirming her faith, Willie Mae named one of her sons after the early Methodist spiritual leader John Wesley, whose principles of social justice later surfaced in peculiarly twisted forms in the musings of Willie Mae’s novelist granddaughter. Underscoring the family’s religious bent, Willie Mae’s grandparents William and Elizabeth Stewart had spent eleven years in the “strict Presbyterian community” of Rogersville, Tennessee (even though Elizabeth was a Methodist), a community founded by the grandparents of the legendary American frontiersman Davy Crockett. Their eighth child, Oscar Wilkinson Stewart, Willie Mae’s father, was first a schoolmaster and then a doctor who served out his Civil War duties as a surgeon."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00008",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unlike the Coates family into which his granddaughter Willie Mae would marry, William Stewart disapproved of the institution of slavery and never owned slaves himself. But the Stewarts’ nine sons all served in the Confederate army and all of them were Masons.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This is straightforward enough as a family history—even with the family emphasis on radiant piety, and with what must have been troubling family divisions on the subjects of religion and slave owning. But then, slowly, something almost as interesting as the Presbyterian/Methodist split starts to work its way though successive generations of the Stewart family. Sets of brothers and sisters begin to marry other sets of sisters and brothers—as though the Stewart family were gradually developing double vision. The pious William Stewart, married to the saintly Elizabeth Decherd, had a brother, Charles Stewart. Charles Stewart married his brother’s wife’s sister, Ellen Decherd. Then two of William and Elizabeth Stewart’s sons, Oscar Wilkinson and Leonidas, married the Pope sisters, Mary Ann Pope and Martha Clarissa Pope. And then two of Oscar Wilkinson Stewart’s daughters, Martha and Willie Mae, married the Coates boys, Andrew Jackson Coates and Daniel Hokes Coates.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat Highsmith, who in later life entertained a mystical belief in the inherited properties of “blood,” would have known just what to say about all this doubling up and religious division in her family. She would have said that double trouble was in her blood from the moment she was conceived—and she would have blamed her mother, Mary, for it, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daniel Hokes Coates, Willie Mae’s husband, was the son of Gideon Coats, the man who founded Coats’ Bend, Alabama. Coats’ Bend was the Coates family’s Big Historical Moment, one they never forgot. Like any Founding Father, Gideon Coates got his land from the Native Americans, the Cherokees: five thousand acres of it. Although the Coateses’ founding of this township and the Coates family’s Confederate war history figured largely in Pat’s imagination,"), _c('span', {
    staticClass: "endnoteRef",
    attrs: {
      "id": "fnt21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end02#fnt_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _vm._v(" the Coates she lived with, her grandfather Daniel Coates, made little impression on her. In the current generation of Coateses’, only Willie Mae, Mother Mary, and her cousin Dan were “real” for Pat. Still, almost all the Coates males were named for Willie Mae’s husband, Daniel Hokes Coates, and for Willie Mae’s father, Oscar Wilkinson Stewart. Willie Mae’s great-grandson Don Coates explains the family’s richly confusing tendency to double its nomenclature:")]), _vm._v(" "), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("My great-grandfather was Dan’l Hokes Coates (Willie Mae’s husband). My grandfather was Dan Oscar Coates—the Oscar comes from the Stewarts [Willie Mae’s father, Oscar Wilkinson Stewart]. My father was Dan Oscar Coates. My brother [was] Dan Walton Coates—Walton was the name of my mother’s father. My nephew is Dan Oscar Coates and his…son is Dan Oscar Coates, making him Dan IV. My name is Don Oscar Coates. And then to keep it interesting we had a dog named Dan. No middle name. So around our house you could call for Dan and get my father, brother, nephew, and dog….")]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_vm._v("And by the way, I was usually called Dan when addressed."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00009",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mary Coates repeated the family custom (it was another way of reproducing herself) when she gave her own first name to her only child. “Mary” was a name Pat Highsmith refused to live or die with, but she used it in her most revealing early short story, “The Legend of the Convent of St. Fotheringay,” and in many stories thereafter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some instinct for strict propriety, upright appearance, and the desire not to be confused with criminals—Pat sustained this odd combination of urges all her life—caused the Coats family, sometime after Coats’ Bend was incorporated, to add an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e")]), _vm._v(" to their last name. It seems, says Don Coates, that in Alabama “there were some men named Coats who were horse thieves and in those days [that was] the worst thing you could be. They hung you right on the spot. The family changed the name to Coates so that everyone in the South would know they weren’t connected with the kind of people who would steal horses.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00010",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Coats’ Bend, Alabama, was the site of the original of the many “houses of fiction” that figured in Pat Highsmith’s life and work: the white, fourteen-room “Coats’ Mansion” built in 1842 by Pat’s slave-owning great-grandfather Gideon Coats in the best mortise-and-tenon tradition of fine carpentry, without the use of a single nail. Willie Mae, whose boardinghouse in Fort Worth was a working-class version of the plantation-style “mansion,” embroidered a picture of the Coats’ Mansion for her Fort Worth wall, and her son Edward did the same thing for his wall."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00011",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" Pat kept a photograph of the Coats’ Mansion in one of her albums, referred to it regularly in her letters, and built it and rebuilt it in various ways in her novels. And in all her domiciles, she managed to reproduce something of the mansion’s plantation ethos, inveigling some of her poorer neighbors into genial servitude and persuading wealthier friends and family members to run errands and do chores for her. Even at her most financially reduced, when she was just out of college and living in a one-room studio in Manhattan, Pat always had a weekly “maid” in to help with the cleaning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In her mind, Pat settled quite comfortably into what Gore Vidal likes to call “Margaret Mitchell Country.” She was quick to cite "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gone with the Wind")]), _vm._v(" as her favorite novel, insisting that it was “a true novel of the South.” (In that irresistible book, loyal, happy slaves serve their romantically unhappy masters until the Marauding Northerners come to Lay Waste to Our Southern Way of Life. And that’s when Scarlett O’Hara, a feminist "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("avant la lettre,")]), _vm._v(" decides to act now and think about the consequences “tomorrow.”) In 1977, Pat added to her preference for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gone with the Wind")]), _vm._v(" the opinion that her great-grandfather Gideon Coats’s “110 body-slaves” (she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("loved")]), _vm._v(" the phrase “body-slaves”) were “not unhappy.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00012",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("13")])])]), _vm._v(" The dreams and values of the Old South were still working their Mason-Dixon Line magic in Pat’s imagination, fifty years after she’d heard them told to her in her grandmother’s kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Willie Mae and Dan Coates and their five children travelled to Fort Worth, Texas, from Coats’ Bend, Alabama, in 1904, mostly, says their great-grandson Don, because Dan Coates’s sister Dolly was given the Coats’ Mansion as well as the family cotton gin and grist mill, and Dan and Willie Mae didn’t want to “carry the rest of the family financially.” When the Coateses went west, they travelled in style. Family legend has it that Willie Mae and Daniel “had all their possessions…the crystal and china and silver and all of that packed into bales of cotton and they rented a [railway car] and put all of those bales of cotton with the crystal and the china and the silver in the train car with all their furniture and then they rented another railway car for the family itself.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00013",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It’s like a fairy tale, and it probably "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" a fairy tale: the entire family travelling from Alabama to Texas in a private railway car with everything they owned wrapped up in snowy bales of cotton. But it was the trains themselves (along with the strict timetables that governed them) and not the billowing cotton bales that would catch the imagination of the family’s writing granddaughter."), _c('span', {
    staticClass: "endnoteRef",
    attrs: {
      "id": "fnt22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end02#fnt_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Somewhere on that cross-country journey, despite the private railway car and the wrapped-in-cotton furniture, Willie Mae and her family seem to have gotten a lot poorer. By the time they fetched up in Fort Worth, a modest boardinghouse was all they could afford, and Daniel Coates went to work driving a wagon to deliver the local newspaper, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fort Worth Star-Telegram,")]), _vm._v(" in downtown Fort Worth."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00014",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("15")])])]), _vm._v(" But the life the Coates family constructed in Fort Worth was a demotic version of the plantation life they’d left behind. There was, first, the Main House on West Daggett Avenue in which boarders were housed and fed by Willie Mae and at which factory workers sometimes took their meals. Pat, deploring the downward transmission of the Coateses, always referred to the boarders as “gentlemen,” but, said Dan Walton Coates, they were “just steady working people,” people")]), _vm._v(" "), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("who did factory-type work, single males with the exception of one couple who lived downstairs, the Syleses, and he did a lot of maintenance work for my grandma on the place. She probably swapped part of the work for rent. People who stayed there were not transients. They had fairly good jobs. There was a man there that repaired violins. They were long-termers. Willie Mae ran the show."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00015",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then there was the shack-filled alley behind the house, called, in the locution of the times, “Negro Alley” or “Nigger Alley,” or “Red Alley” because of the color of the shack roofs. There were back-shacks like these all over Fort Worth, rented out to blacks who worked in the yards and houses of Fort Worth whites. The workers would otherwise have had to travel long distances from far-away communities to get to their yard jobs in Fort Worth. So they slept out in back of main houses in little rented shacks."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00016",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dan Walton Coates remembered staying at his great-grandmother’s boardinghouse one night when “there was a hell of a racket [in Negro Alley]…music going and loud talking.” Willie Mae jumped out of bed in the middle of the night, her hair still in curlers, grabbed a robe, and told young Dan that they were going out back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And there was a fellow [living] out there, he was big as a mountain and his name was House…. We walked back there and that place was full and everybody was outside having a big party in a little common ground area. And I’m not but about seven or eight years old and Grandma walked right through the middle of that thing and found House and told him [in the accepted parlance of the day] that the party was over: ‘You get these niggers back where they belong and I don’t want to hear another word out here!’ And he said ‘Oh yes, Mrs. Coates,’ and with that, we turned around and went back to the house and it got quiet as a jug.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Don Coates believes that the “House” of this incident, whose last name was also Coates, was an emancipated slave who had been trained to work in the Coats’ Mansion in Alabama, where he would have been given the Coates family surname and called “House” by his mother, a common custom with “house slaves.” House Coates was probably Daniel Hokes Coates’s personal slave when Daniel was a child during the Civil War—all the Coates children had slaves of their own—and he came with the Coates family on their mythical cotton-swathed journey from Alabama. The family would have felt responsible for him, Don says, and wouldn’t have left him behind in Alabama if he didn’t want to stay there. House Coates was set up out back in one of the little shacks, just as, in pre–Civil War circumstances, he would have been set up in the old slave quarters behind the Coats’ Mansion in Coats’ Bend."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00017",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And so Pat Highsmith, who wrote to her stepfather in 1970 that “[m]y character was essentially made before I was six,”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00018",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("19")])])]), _vm._v(" had, until she was taken to Manhattan by her mother at the age of six, a model for living that was much closer to antebellum Alabama than it was to anything else. Born in Texas, Pat grew up, as her antic Alabama-born friend Eugene Walter reminded her, with “Alabama genes.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00019",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But if her links with Alabama were inborn and enculturated, the signs and symbols of Pat’s home state of Texas seem to suit her just as well. Texas is known as the “Lone Star State” there was never a loner star than Patricia Highsmith. Yellow, Pat’s favorite color, is reminiscent of the famous Yellow Rose of Texas. The reptile most often associated with Texas, the rattlesnake, has been depicted on banners in America since 1775—all of them inscribed with some version of the phrase “Don’t Tread on Me,” a motto Pat could comfortably have embossed on her business cards. The state of Texas would always have a great deal to do with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("all")]), _vm._v(" the states Patricia Highsmith found herself in.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Mary Coates Highsmith was Willie Mae’s youngest child. She was preceded in the Coates family by four favored brothers, and she complained to her daughter that Willie Mae “went to her grave never letting me know that I had made the grade.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00020",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("21")])])]), _vm._v(" But Mary kept trying, plaintively, to get her mother’s attention by “doing things” for her. She gave Willie Mae “trips to NY on three different occasions…. None of my brothers did it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ever")]), _vm._v(".” For which Willie Mae “could never bring herself to genuinely thank me, but that was HER block and she was stuck with it ’til her death.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00021",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("22")])])]), _vm._v(" And Pat, pitiless in her observations of her mother in later life, found Mary’s repeated attempts to make a good impression on Willie Mae painfully hard to think about.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now my poor mother is even ashamed to return to Texas for a visit because she needs a new bag, hasn’t a winter coat, & because they are all swimming in money there. This fills me with more tragic emotion than I realize consciously & accounts for much of my depression lately.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00022",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Subtly, and by degrees, little Patsy Plangman, taught to read by her grandmother (no memory could be more important for a writer, and Pat refers to it often, changing her stories of how and when it happened), and raised up for most of her first six years in a household dominated by Willie Mae, seems to have become more like a sibling to her mother than a daughter. Mary’s and Pat’s later behaviors, their letters to each other and notes to themselves, and their lengthy arguments, were often driven by what looks very much like sibling competition.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mary to Pat:")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She [Willie Mae] treated you [Pat] differently than she did me. It was as if she was not the same person…. But my father wasn’t like that—he told her I was better than all the boys put together.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00023",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat to herself:")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Anyway, she [Mary] is safe in her insanity, safe in being on home ground, Texas; safe in having a nephew, one of the family, dancing attendance…. I must not forget that my grandmother (her mother) remarked, ‘Mary is insane,’ when my mother was 44.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00024",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat and Mary would quarrel, with the jealousy going every which way, about the “possession” of their mutual friends, and Mary warned Pat when she was in high school not to write to her fashion illustrator chums, Marjorie Thompson and Jeva Cralick."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00025",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("26")])])]), _vm._v(" Then Pat upset Mary by taking over Mary’s friendship with Jean David (known as “Jeannot”), the young French cartoonist from Marseille who was Mary’s foreign pen pal and who had stayed with the Highsmiths in Manhattan when Pat was still a teenager."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00030"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00026",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("27")])])]), _vm._v(" Although Jean David signed himself “Jeannot” in his letters to both Mary and Pat, and although Mary and Pat each had her own pages in his family photo albums, Jeannot kept many more photos of Pat than he kept of Mary. (See "), _c('span', {
    attrs: {
      "href": "#/9780312303754_ch18#k1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("illustrations")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like a jealous sibling, Pat sometimes cautioned her lovers and friends not to get too close to her mother. She loved to tell tales on Mary to her grandmother, and, siblinglike, Mary found out about the stories and berated Pat:")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then I learned to my horror you flatly lied about me to Mamma to the effect that I was jealous of you being at Yaddo…. God how that information shook me.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00027",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pat said that jealousy was the emotion she hated the most—“No, I shall never be jealous, only die of jealousy”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00032"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00028",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("29")])])]), _vm._v("—but her complicated, divided childhood was wreathed in it.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Willie Mae Coates’s ideas about family responsibility were strong ones. Seven years before Pat was born, Willie Mae, a “reading” woman with phenomenal energy, “a big library,” and a strong interest in public affairs (the heritage of her strict Presbyterian/Methodist upbringing), took charge of Mary’s nephew and Pat’s first cousin, Dan Coates, father of Dan Walton and Don Coates and the son of her own dead son Daniel. Young Dan’s mother had been “a bride, a widow, and a mother” within ten months and then died suddenly when Dan was three."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00033"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00029",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("30")])])]), _vm._v(" And young Dan, said his eldest son, Dan Walton, “identified with Pat a great deal because [he] felt like an orphan and Pat felt like she was an orphan too.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00034"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00030",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("31")])])]), _vm._v(" In their lifelong correspondence, Dan and Pat always addressed each other as siblings: “sis Pat” and “brother Dan.” And Mary, too, said Dan Walton Coates, “was more a sister to my father than an aunt” because they were both raised by Willie Mae."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00035"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00031",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Given this unusual history—the magnet-grandmother to whom the loose family filings returned to have their relations reordered—it is not so remarkable that adoptions, actual and figurative, are a recurrent theme in much of Pat Highsmith’s work, beginning with her first, unfinished novel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Click of the Shutting,")]), _vm._v(" and continuing on through her posthumous novel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Small g")]), _vm._v(". But as in Pat’s own family (and as in the fictions of Colette, whom Pat admired), many of the “orphans” who appear in her novels are also well provided with parents."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00036"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00032",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On Dan Coates’s eightieth birthday (that’s the Dan who was raised with Pat in Willie Mae’s boardinghouse) he told his family a story about Willie Mae, a story which still impressed him greatly although it had occurred more than seventy years before. One day, Dan said, Willie Mae was in her kitchen, and Dan, just a little boy at the time, came up behind her, put an arm around her waist, and patted her affectionately on the upper leg. And Willie Mae turned around to him and said very firmly: “Young man, don’t you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ever")]), _vm._v(" touch me "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in that way again")]), _vm._v("!” Dan never did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dan’s son Don says that physical and verbal manifestations of affection were never part of the Coates family lexicon, although love was offered in every other way. “Aunt Mary didn’t know how to touch Pat or use the words. It was the whole Victorian sort of thing…and Grandma was definitely a Victorian…. That was how [Mary] was raised. [Physical expression] just wasn’t there because they just didn’t know how to do it.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00037"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00033",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("34")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Willie Mae was far more lenient with her granddaughter, Pat, than she had ever been with her daughter, Mary, and almost all Pat’s memories of her grandmother are exalted and idealized. A born hero-worshipper, Pat filled in the generation that separated her from Willie Mae with a version of heroic grandmotherhood so unassailable that she could never write about it. Although Pat said that it was “much easier to create from positive, affectionate emotions than from negative and hateful ones,”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00038"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00034",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("35")])])]), _vm._v(" she rarely did so, and in a sentence whose meaning is almost as confused as the intentions which provoked it, she seems to have excluded the possibility of ever writing about Willie Mae: “If I ever write about my grandmother, it will have to be very good or not at all.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00039"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00035",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("36")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then there is this circumstance to think about. Little Patsy Plangman was a particularly androgynous child. Photographs of her from the age of one upward are ambiguously gendered: she could be a girly boy or a boyish girl. Mary kept Patsy’s infant hair short and fashionable, and at three she looks like a little flapper, with her hair in a bowl cut. By the age of twelve, Pat’s own preference was for boys’ clothes, and she had already adopted a style: dressing herself in a cap and knickers like Jackie Coogan in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Kid,")]), _vm._v(" a film she might have seen with Willie Mae, who, twenty years later, was still faithfully taking her great-grandsons every single Saturday to the double-featured Westerns and comedies at the Hollywood and the Palace theaters in downtown Fort Worth."), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00040"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00036",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("37")])])]), _vm._v(" There is a photograph of Pat in her cap and knickers, unsettlingly boyish and looking out from the frame with a boy’s audacious stare; she’s ready with a challenge and spoiling for a fight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In a vignette Pat tailored for the “suspense market,” the “market” in whose category she always stirred so restively, she remembered herself at the age of four “racing barefoot in my dropseat overalls down the hall to pick up the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fort Worth Star-Telegram")]), _vm._v(" from the front porch, and racing back to the kitchen to read aloud to my Scots grandmother. This was my first adventure story, strung out with all the suspense of installments.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00041"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00037",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("38")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Patsy is reading at four all right—part of the point of her anecdote is to show that off—and she is reading “suspense,” too, and to her beloved grandmother. But the newspaper story she is reading would have been ripped out of the hands of any four-year-old today: the gothic, gruesome Floyd Collins saga, a true-life horror story that began when a Kentucky hillbilly was trapped by a rockslide in a cavern near his home at the end of January 1925. It took two dreadful weeks to dig the expiring Collins out—and every moment of his death agony was reported on in installments by the popular press.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yes, Patsy is reading, but she is also running in bare feet and dropseat overalls to pick up the newspaper. And overalls (not to mention bare feet) were not a general feature of the wardrobes of proper little girls in 1925. The fact that Patsy was more like a proper little boy than a proper little girl is the nugget of information concealed in this well-polished reminiscence. Despite her later and always-doomed attempts to live and love like a good bourgeoise, Pat never could change her nature. She was most at home in the gay bars of Greenwich Village in the 1940s and 1950s and in the lesbian boîtes of Paris and Berlin in the 1970s, where she could appear—with some purpose at last—in the semidrag she wore all her adult life: the starched and ironed oxford shirts, the Levi-Strauss 501 jeans, the men’s loafers, the handsome cravats, the trim little vests. Grandmother Willie Mae, a woman whose preference for sons was undoubtedly reawakened by her granddaughter’s androgyny, never had a word of criticism to say to Pat about the way she dressed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the age of sixty-six, Mary Highsmith was still complaining that she hadn’t been given roller skates as a child when all her brothers got them, and that her mother Willie Mae’s reproving “look” left her “sweating blood.”"), _c('span', {
    staticClass: "xrefInternal",
    attrs: {
      "id": "en_ref_00006_00042"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312303754_end01#en_des_00006_00038",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("39")])])]), _vm._v(" Pat always had Willie Mae to compare her mother to, and her mother always came up short. And it is likely that Willie Mae’s partiality for boys laid the foundation for Pat’s own later preference for the “active and positive” qualities of men instead of for the “negative and passive” gender with which she so inconveniently continued to fall in love. And so Pat’s attentions and affections continued to be split by the circumstances of her birth—circumstances which tightened the passionate lines of tension between mother and daughter and blurred the boundaries between love and hate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In this house of trespassed borders and reordered relations one clear principle flew like a flag: Willie Mae Stewart Coates was the head of the family.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b563e17e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312303754_ch06.vue
// module id = 87
// module chunks = 0